import { createSlice } from '@reduxjs/toolkit';
import { IItem } from './inventorySlice';

export interface ChatItemSnapshot {
  iid: number;
  core?: IItem['core'];
  props: IItem['props'];
}

export interface Message {
  nameColors?: string[];
  nameNeon?: boolean;
  titleId?: number;
  vip?: boolean;
  svip?:boolean;
  village?: number;
  user: string;
  id: number;
  serverId: number;
  message: string;
  kind?: 'system';
  serverNoticeColor?: string;
  localNotice?: 'success' | 'error';
  announcement?: {
    type: 'arena' | 'challenge_win' | 'challenge_loss' | 'pot' | 'random' | 'enhance' | 'ninja_box' | 'gacha' | 'transfer_guard'; player: string;
    opponent?: string; opponentKey?: boolean; level?: number; amount?: number;
    item?: ChatItemSnapshot;
  };
}

interface State {
  global: Message[];
  party: Message[];
  system: Message[];
  talk: Message[];
}

const initialState: State = {
  global: [],
  party: [],
  system: [],
  talk: [],
};

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    addPrivateSystemMessage: (state, action) => {
      state.global.push(action.payload);
      state.system.push(action.payload);
      if (state.global.length > 200) state.global.shift();
      if (state.system.length > 200) state.system.shift();
    },
    addGlobalMessage: (state, action) => {
      state.global.push(action.payload);
      state.talk.push(action.payload);
      if (state.talk.length > 200) state.talk.shift();

      if (state.global.length > 200) {
        state.global.shift();
      }
    },
    addPartyMessage: (state, action) => {
      state.party.push(action.payload);

      if (state.party.length > 200) {
        state.party.shift();
      }
    },
    addSystemMessage: (state, action) => {
      state.global.push(action.payload);
      state.system.push(action.payload);
      if (state.global.length > 200) state.global.shift();
      if (state.system.length > 200) state.system.shift();
    },
  },
});

export const { addGlobalMessage, addPartyMessage, addSystemMessage, addPrivateSystemMessage } = chatSlice.actions;

export default chatSlice.reducer;
